import $ from "jquery"
import EntityNode from "./EntityNode"
import SimpleTooltip from "../../../SimpleTooltip"
import messageResource from "../../../messageResource"
import EditButton from "../../EditButton"
import {setEventPreventHidingEditProjectSlidingPanel} from "../../../panels/utils"

export default class ProjectNode extends EntityNode {

    constructor({
        tokensHighlighter,
        project,
        onClick = () => {},
    }) {
        super({tokensHighlighter, onClick})
        this.project = project
    }

    templateHtml() {
        return "<div class='node projectNode'>" +
               "  <div class='icon'></div>" +
               "  <div class='title'>" +
               "    <div class='text'><%=title%></div>" +
               "    <div class='archivedLabel'><%=archivedLabel%></div>" +
               "  </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            archivedLabel: "common.archived"
        }
    }

    title() {
        return this.project.name;
    }

    afterRender() {
        super.afterRender();

        if (!this.editButton) {
            this.editButton = new EditButton(this.$el).init();
        }
        this.editButton.setClickHandler((e) => {this._editButtonClickHandler(e)});

        let editTooltip = this.editTooltip();
        editTooltip.subscribeToMouseEvents(this.editButton.$el);

        $(this).on("hide_tooltip", function() { editTooltip.hide() });

        this.$el.toggleClass("archived", this.project.archived);
        this.renderInitialState()
    }

    _editButtonClickHandler(e) {
        setEventPreventHidingEditProjectSlidingPanel(e);
        $(document).trigger("taskManagement_customersProjectsPanel_viewProject", this.project.id);
        $(this).trigger("hide_tooltip");
        this.preventNextClick = true;
    }

    getId() {
        return this.project.id
    }

    editTooltip() {
        if (!ProjectNode.tooltip) {
            ProjectNode.tooltip = new SimpleTooltip({
                text: messageResource.getMessage('task.list.tooltip.project_edit'),
            }).init($('body'))
        }
        return ProjectNode.tooltip
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/ProjectNode.js